import '../styles/games.css';

const games = [
  {
    name: 'EAFC',
    image: '/images/games/fc_2.jpg',
    genre: 'Sports',
    players: '1v1, 2v2',
    color: '#FFD700',
  },
  {
    name: 'Call of Duty',
    image: '/images/games/cod_2.jpg',
    genre: 'Shooter',
    players: 'Solo, Teams',
    color: '#ff0000',
  },
  {
    name: 'PUBG',
    image: '/images/games/pubg_2.jpg',
    genre: 'Battle Royale',
    players: 'Solo, Squads',
    color: '#FFD700',
  },
  {
    name: 'Tekken',
    image: '/images/games/tekken_2.jpg',
    genre: 'Fighting',
    players: '1v1',
    color: '#ff0000',
  },
  {
    name: 'NBA 2K',
    image: '/images/games/nba_1.jpg',
    genre: 'Sports',
    players: '1v1, 2v2',
    color: '#FFD700',
  },
  {
    name: 'Mortal Kombat',
    image: '/images/games/mk_1.jpg',
    genre: 'Fighting',
    players: '1v1',
    color: '#ff0000',
  },
  {
    name: 'Fortnite',
    image: '/images/games/fortnite_1.jpg',
    genre: 'Battle Royale',
    players: 'Solo, Squads',
    color: '#FFD700',
  },
];

function GamesSection() {
  return (
    <section className="games-section">
      <div className="games-container">
        <div className="games-header">
          <span className="games-badge">Top Games</span>
          <h2 className="games-title">Most Played on Cheda Gaming</h2>
          <p className="games-subtitle">Compete in tournaments for your favorite games and win big!</p>
        </div>
        <div className="games-grid">
          {games.map((game, idx) => (
            <div className="game-section-card" key={idx} style={{ '--game-color': game.color } as React.CSSProperties}>
              <div className="game-section-image-wrapper">
                <img src={game.image} alt={game.name} className="game-section-image" />
              </div>
              <div className="game-section-info">
                <h3 className="game-name">{game.name}</h3>
                <span className="game-genre">{game.genre}</span>
                <span className="game-players">{game.players}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default GamesSection; 